// src/api/apiUser.jsx
import { createAPI } from "./apiFactory";
const userAPI = createAPI("access", "/login");
export default userAPI;
